import React, { Dispatch, SetStateAction } from "react";
import { TableColumn } from "react-data-table-component";
import {
  ChangeItemValueTypeEnum,
  CompanySettingModel,
  DailyTransactionTypeEnum,
  RowStateEnum,
  TransactionDetailResponseModel,
  TransactionItemResponseModel, UserSettingModel, UserTransactionsSettingResponseModel,
} from "../../../../models";
import {
  getLabelName,
  roundNumber,
} from "../../../../utils";
import {
  handleDeleteItem,
  handleRefundTransactionItemSelectStatus,
} from "../businessLogic/transactionBl";
import { ConditionalStyles } from "react-data-table-component";
import {
  handleCalculateExistItemValuesChange,
  UpdateTransactionItemStateOnChange,
} from "../businessLogic/commonBl";
import { ButtonBox } from "../../..";

export const getRefundTransactionItemsColumns = (
  isArabic: boolean,
  setState: Dispatch<SetStateAction<TransactionDetailResponseModel>>,
  stateValue: TransactionDetailResponseModel
): TableColumn<TransactionItemResponseModel>[] => {
  return [
    // {
    //   name: "#",
    //   selector: (_row, index) => Number(index || 0) + 1,
    //   width: "50px",
    // },
    {
      name: (
        <input
          type="checkbox"
          id={`checkbox_refund_all_items}`}
          onChange={(event: any) => {
            setState({
              ...stateValue,
              TransactionDetaillist: handleRefundTransactionItemSelectStatus(
                stateValue.TransactionDetaillist,
                null,
                event.target.checked
              ),
            });
          }}
        />
      ),
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="checkbox"
          id={`checkbox_refund_id${index}`}
          checked={row.rowState === RowStateEnum.Add}
          onChange={(event: any) => {
            setState({
              ...stateValue,
              TransactionDetaillist: handleRefundTransactionItemSelectStatus(
                stateValue.TransactionDetaillist,
                row.rowKey,
                event.target.checked
              ),
            });
          }}
        />
      ),
    },
    {
      name:  getLabelName("ItemCode"),
      selector: (row) => row.ItemCode || "",
      sortable: true,
    },
    {
      name:getLabelName("ItemName"),
      selector: (row) => (isArabic ? row.ItemName : row.ItemName_En),
      sortable: true,
    },
    {
      name: getLabelName("Quantity"),
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`return_quantity_key_${index}`}
          value={row.Quantity}
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
          onChange={async (e: any) => {
            let val = e.target.value === null ? 0 : Number(e.target.value);
            val = val > row.defaultQuantity ? row.defaultQuantity : val;
            await UpdateTransactionItemStateOnChange(setState, stateValue, {
              ...row,
              changeValueType: ChangeItemValueTypeEnum.None,
              Quantity: val,
            });
          }}
          onBlur={async () => {
            await handleCalculateExistItemValuesChange(
              setState,
              stateValue,
              row
            );
          }}
        />
      ),
      width: "100px",
    },
  ];
};
export const getTransactionItemsColumns = (
  isArabic: boolean,
  transactionType: DailyTransactionTypeEnum,
  setState: Dispatch<SetStateAction<TransactionDetailResponseModel>>,
  stateValue: TransactionDetailResponseModel,
  companySettings: CompanySettingModel,
  userTransactionSetting:UserTransactionsSettingResponseModel,
  userSetting:UserSettingModel
): TableColumn<TransactionItemResponseModel>[] => {
  const isRefund = isRefundTransaction(transactionType);
  let columns: TableColumn<TransactionItemResponseModel>[] = [
    {
      // name: (
      //   <label style={{ width: "fit-content" }}>
      //     {getLabelName("ItemCode")}
      //   </label>
      // ),
      name: getLabelName("ItemCode"),
      selector: (row) => row.ItemCode || "",
      sortable: true,
    },
    {
      // name: (
      //   // <div style={{ width: "fit-content" }}>{getLabelName("ItemName")}</div>
      //   <label style={{ width: "fit-content" }}>
      //     {getLabelName("ItemName")}
      //   </label>
      // ),
      name: getLabelName("ItemName"),
      selector: (row) => (isArabic ? row.ItemName : row.ItemName_En),
      sortable: true,
    },
    {
      name: getLabelName("Quantity"),
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`quantity_key_${index}`}
          value={row.Quantity}
          min={0}
          step={1}
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
          onChange={async (e: any) => {
            const val = e.target.value === null ? 0 : Number(e.target.value);
            await UpdateTransactionItemStateOnChange(setState, stateValue, {
              ...row,
              changeValueType: ChangeItemValueTypeEnum.None,
              Quantity: val,
            });
          }}
          onBlur={async () => {
            await handleCalculateExistItemValuesChange(
              setState,
              stateValue,
              row
            );
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Price"),
      id: "price_column",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`price_key_${index}`}
          readOnly={isRefund || !userTransactionSetting.EnableShangPrice}
          value={row.Unit_Price}
          min={0}
          step="0.01"
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
          onChange={async (e: any) => {
            const val = e.target.value === null ? 0 : Number(e.target.value);
            await UpdateTransactionItemStateOnChange(setState, stateValue, {
              ...row,
              changeValueType: ChangeItemValueTypeEnum.ChangePrice,
              Unit_Price: val,
            });
          }}
          onBlur={async () => {
            await handleCalculateExistItemValuesChange(
              setState,
              stateValue,
              row
            );
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Price"),
      id: "price_inCurrency_column",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`price_in_currency_key_${index}`}
          readOnly={isRefund || !userTransactionSetting.EnableShangPrice}
          value={row.Unit_PriceInCurrencyCalculated}
          min={0}
          step="0.01"
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
          onChange={async (e: any) => {
            const val = e.target.value === null ? 0 : Number(e.target.value);
            await UpdateTransactionItemStateOnChange(setState, stateValue, {
              ...row,
              changeValueType: ChangeItemValueTypeEnum.ChangePriceInCurrency,
              Unit_PriceInCurrencyCalculated: val,
            });
          }}
          onBlur={async () => {
            await handleCalculateExistItemValuesChange(
              setState,
              stateValue,
              row
            );
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Price_With_Tax"),
      id: "price_with_tax_column",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`price_with_tax_key_${index}`}
          readOnly={isRefund || !userTransactionSetting.EnableShangPrice}
          value={row.UnitPriceWithTaxCalculated}
          min={0}
          step="0.01"
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
          onChange={async (e: any) => {
            const val = e.target.value === null ? 0 : Number(e.target.value);
            await UpdateTransactionItemStateOnChange(setState, stateValue, {
              ...row,
              changeValueType: ChangeItemValueTypeEnum.ChangePriceWithTax,
              UnitPriceWithTaxCalculated: val,
            });
          }}
          onBlur={async () => {
            await handleCalculateExistItemValuesChange(
              setState,
              stateValue,
              row
            );
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Price_With_Tax"),
      id: "price_with_tax_inCurrency_column",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`price_with_tax_inCurrency_key_${index}`}
          readOnly={isRefund || !userTransactionSetting.EnableShangPrice}
          value={row.UnitPriceWithTaxInCurrency}
          min={0}
          step="0.01"
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
          onChange={async (e: any) => {
            const val = e.target.value === null ? 0 : Number(e.target.value);
            await UpdateTransactionItemStateOnChange(setState, stateValue, {
              ...row,
              changeValueType:
                ChangeItemValueTypeEnum.ChangePriceWithTaxInCurrency,
              UnitPriceWithTaxInCurrency: val,
            });
          }}
          onBlur={async () => {
            await handleCalculateExistItemValuesChange(
              setState,
              stateValue,
              row
            );
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("PriceCost"),
      id: "price_cost_column",
      cell: (row: TransactionItemResponseModel, index) => (
          <input
              type="number"
              className="form-control"
              key={`price_cost_key_${index}`}
              //readOnly={isRefund || !userTransactionSetting.EnableShangPrice}
              value={row.PriceCost}
              min={0}
              step="0.01"
              onWheel={(event) => {
                event.currentTarget.blur();
              }}
              onChange={async (e: any) => {
                const val = e.target.value === null ? 0 : Number(e.target.value);
                await UpdateTransactionItemStateOnChange(setState, stateValue, {
                  ...row,
                  PriceCost:val,
                });
              }}
              // onBlur={async () => {
              //   await handleCalculateExistItemValuesChange(
              //       setState,
              //       stateValue,
              //       row
              //   );
              // }}
          />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Discount"),
      id: "discount_colum",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`discount_key_${index}`}
          readOnly={isRefund}
          value={row.ItemDiscount}
          min={0}
          step="0.01"
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
          onChange={async (e: any) => {
            const val = e.target.value === null ? 0 : Number(e.target.value);
            await UpdateTransactionItemStateOnChange(setState, stateValue, {
              ...row,
              changeValueType: ChangeItemValueTypeEnum.None,
              ItemDiscount: val,
            });
          }}
          onBlur={async () => {
            await handleCalculateExistItemValuesChange(
              setState,
              stateValue,
              row
            );
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Discount"),
      id: "discount_inCurrency_colum",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`discount_inCurrency_key_${index}`}
          readOnly={isRefund}
          value={row.ItemDiscountInCurrency}
          min={0}
          step="0.01"
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
          onChange={async (e: any) => {
            const val = e.target.value === null ? 0 : Number(e.target.value);
            await UpdateTransactionItemStateOnChange(setState, stateValue, {
              ...row,
              changeValueType: ChangeItemValueTypeEnum.ChangeDiscountInCurrency,
              ItemDiscountInCurrency: val,
            });
          }}
          onBlur={async () => {
            await handleCalculateExistItemValuesChange(
              setState,
              stateValue,
              row
            );
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Tax"),
      id: "item_tax_column",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`item_tax_key_${index}`}
          value={row.Tax}
          readOnly={true}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("t_i_c"),
      id: "item_tax_inCurrency_column",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`item_tax_inCurrency_key_${index}`}
          value={row.TaxInCurrency}
          readOnly={true}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Total_Tax"),
      id: "item_total_tax_column",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`item_total_tax_key_${index}`}
          value={row.TotalTax}
          readOnly={true}
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("t_t_i_c"),
      id: "item_total_tax_inCurrency_column",
      cell: (row: TransactionItemResponseModel, index) => (
        <input
          type="number"
          className="form-control"
          key={`item_total_tax_inCurrency_key_${index}`}
          value={row.TotalTaxInCurrency}
          readOnly={true}
          onWheel={(event) => {
            event.currentTarget.blur();
          }}
        />
      ),
      width: "100px",
    },
    {
      name: getLabelName("Total"),
      id: "total_column",
      selector: (row) => row.Total,
      sortable: true,
      width: "100px",
    },
    {
      name: getLabelName("Total"),
      id: "total_inCurrency_column",
      selector: (row) => roundNumber(row.TotalInCurrency),
      sortable: true,
      width: "100px",
    },
    {
      // eslint-disable-next-line react/button-has-type
      cell: (row: TransactionItemResponseModel) => (
        <ButtonBox
          id="deleteItemBtn"
          variant="danger"
          className="btn-xs"
          onClick={async () => {
            await handleDeleteItem(setState, stateValue, row);
          }}
        >
          {getLabelName("Delete")}
        </ButtonBox>
      ),
    },
  ];
  if (!companySettings.ApplyTax) {
    columns = columns.filter(
      (column) => column.id !== "price_with_tax_inCurrency_column"
    );
    columns = columns.filter(
      (column) => column.id !== "item_tax_inCurrency_column"
    );
    columns = columns.filter(
      (column) => column.id !== "item_total_tax_inCurrency_column"
    );
  }
  if (isRefund) {
    columns = columns.filter(
      (column) => column.id !== "price_with_tax_inCurrency_column"
    );
    columns = columns.filter(
      (column) => column.id !== "item_tax_inCurrency_column"
    );
    columns = columns.filter(
      (column) => column.id !== "item_total_tax_inCurrency_column"
    );
  }
    if (!userTransactionSetting.EnableDiscount) {
        columns = columns.filter((column) => column.id !== "discount_inCurrency_colum");
    }
    if(!userTransactionSetting.ShowPrice){
        columns = columns.filter((column) => column.id !== "price_column");
        columns = columns.filter((column) => column.id !== "price_inCurrency_column");
        columns = columns.filter((column) => column.id !== "price_with_tax_column");
        columns = columns.filter((column) => column.id !== "price_with_tax_inCurrency_column");
    }
    if(!userSetting.ShowHintOfItemCost){
      columns = columns.filter((column) => column.id !== "price_cost_column");
    }
  columns = columns.filter((colum) => colum.id !== "price_column");
  columns = columns.filter((column) => column.id !== "price_with_tax_column");
  columns = columns.filter((column) => column.id !== "discount_colum");
  columns = columns.filter((column) => column.id !== "item_tax_column");
  columns = columns.filter((column) => column.id !== "item_total_tax_column");
  columns = columns.filter((column) => column.id !== "total_column");
  columns = columns.filter(
      (column) => column.id !== "item_tax_inCurrency_column"
  );
  columns = columns.filter(
      (column) => column.id !== "item_total_tax_inCurrency_column"
  );
  return columns;
};
export const handleConditionalRowStyles: ConditionalStyles<TransactionItemResponseModel>[] =
  [
    {
      when: (row: TransactionItemResponseModel) => row.Quantity == 2,
      style: {
        backgroundColor: "blue", // Apply your desired highlight style
      },
    },
    {
      when: (row: TransactionItemResponseModel) => row.Quantity == 1,
      style: {
        backgroundColor: "yellow", // Apply your desired highlight style
      },
    },
  ];

export const handleItemRowStyle = (
  request: TransactionItemResponseModel[]
): ConditionalStyles<any>[] => {
  let latestModifiedItem: TransactionItemResponseModel | null = null;
  let latestModifiedDate: Date | null = null;

  // Iterate through the array to find the item with the latest modified date
  for (const row of request) {
    const rowModifiedDate = new Date(row.latestModifiedDate);

    if (!latestModifiedDate || rowModifiedDate > latestModifiedDate) {
      latestModifiedDate = rowModifiedDate;
      latestModifiedItem = row;
    }
  }

  // Apply the highlight style to the row with the latest modified date
  return [
    {
      when: (row: TransactionItemResponseModel) => row === latestModifiedItem,
      style: {
        backgroundColor: "lightblue", // Apply your desired highlight style
      },
    },
  ];
};

export const handleRowStyle = (
  request: TransactionItemResponseModel[]
): ConditionalStyles<any>[] => {
  return [
    {
      when: (row: TransactionItemResponseModel) =>
        row == request[request.length - 1],
      style: {
        backgroundColor: "lightblue", // Apply your desired highlight style
      },
    },
  ];
};

//#region private
const isRefundTransaction = (
  transactionType: DailyTransactionTypeEnum
): boolean => {
  switch (transactionType) {
    case DailyTransactionTypeEnum.SalesRefund:
    case DailyTransactionTypeEnum.PurchasesRefund:
      return true;
    default:
      return false;
  }
};
//#endregion
